/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

type SelectableGoalCardProps = {
  label: string;
  checked: boolean;
  Icon: string;
  onToggle: () => void;
};

export const SelectableGoalCard: React.FC<SelectableGoalCardProps> = ({
  label,
  checked,
  onToggle,
  Icon,
}) => {
  return (
    <label className={`goal-card ${checked ? 'is-checked' : ''}`}>
      <input type="checkbox" className="goal-checkbox" checked={checked} onChange={onToggle} />
      <div className="goal-icon">
        <img src={Icon} alt={Icon} width="100%" />
      </div>
      <span className="goal-label">{label}</span>
    </label>
  );
};
